import angular from 'angular';
import { ColaboradoresResultadoTableController } from './colaboradores-resultado-table.controller';

export class ColaboradoresUploadLoteTableComponent implements angular.IComponentOptions {
    static selector = 'colaboradoresUploadLoteTableComponent';
    static controller = ColaboradoresResultadoTableController;
    static template = require('!!html-loader!./colaboradores-resultado-table.html');
    static transclude = true;
    static bindings = {
        items: '<',
        showSelection: '<',
        selectedItems: '=?',
        onSelectionChange: '&?',
    };
}
